import i18n from 'i18next'
import resources from '../translations/all.json'
import { useTranslation, initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const countries = {
  id: {
    languages: ['en', 'id'],
    defaultLanguage: 'id'
  },
  my: {
    languages: ['en', 'ms'],
    defaultLanguage: 'en'
  },
  th: {
    languages: ['en', 'th'],
    defaultLanguage: 'th'
  }
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'countryLanguage',
  lookup: options => {
    /*
    if (typeof window === 'undefined') {
      return 'id'
    }

    const [, country] = window.location.pathname.split('/')

    return countries[country]?.defaultLanguage
    */
   return 'id'
  }
})

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources,
    defaultNS: 'common',
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'countryLanguage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'locale',
      lookupFromPathIndex: 1,
      caches: ['localStorage', 'cookie']
    },
    fallbackLng: 'id',

    interpolation: {
      escapeValue: false
    }
  })

export {
  useTranslation,
  countries
}
